import type { PreviewSearch } from "@/features/preview/state";

export function gamePageSearch(parameters: URLSearchParams): PreviewSearch {
  const search: Record<string, string | string[] | undefined> = {};

  for (const key of new Set(parameters.keys())) {
    const values = parameters.getAll(key);
    search[key] = values.length === 1 ? values[0] : values;
  }

  return search;
}
